import GalleryContent from "../Gallery/GalleryContent";

const Gallery = () => {
    return(
        <>
            <h2 className="galleryH2">Galleri</h2>
            <div className="galleryCon">
                <GalleryContent />
            </div>
        </>   
    )
}

export default Gallery;